import React from "react";

import { ConfiguratorTypes } from "../../../constants";
import { IImageURL } from "../../../models/nominals";
import { BreakPoint } from "../../../models/screen";
import { getViewportBreakpoint } from "../../../utils/detectMobile";
import { FreeDeliveryButtonTypes } from "../constants";
import { IModularConfiguratorShippingMessage } from "../models";
import { ConfiguratorFreeDelivery } from "./ConfiguratorFreeDelivery";

import styles from "./ConfiguratorShippingCallout.module.scss";

export const ConfiguratorShippingCallout = (props: {
    content: string;
    configuratorType: ConfiguratorTypes;
    shippingMessages?: IModularConfiguratorShippingMessage | null;
    phoneNumber?: string;
    iconURL?: IImageURL | null | undefined;
}): React.ReactNode => {
    const buildDescription = () => {
        let content = props.content;
        if (getViewportBreakpoint() > BreakPoint.SMALL) {
            content = content.replace("<br>", "");
        }
        return (
            <div className={styles.content}>
                {props.iconURL && (
                    <img src={`${props.iconURL}`} aria-hidden="true" alt="" />
                )}
                <span>
                    {content}
                    {!!props.shippingMessages && (
                        <ConfiguratorFreeDelivery
                            freeDeliveryButtonTypes={
                                FreeDeliveryButtonTypes.ICON
                            }
                            configuratorType={props.configuratorType}
                            phoneNumber={props.phoneNumber}
                            shippingMessages={props.shippingMessages}
                        />
                    )}
                </span>
            </div>
        );
    };

    return (
        <>
            <div className={styles.container}>{buildDescription()}</div>
        </>
    );
};
